export default "__VITE_ASSET__CSqi_7____"